import { HttpClient, HttpParams } from '@angular/common/http';
import { VayService } from './vay.service';
import { Injectable } from '@angular/core';
import { VayTreeService } from './vay-tree.service';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MingoErrorsHandler } from './errors-handler.service';
import { BaseURL } from '../vay.config';
import { VayAntService } from './vay-ant.service';

@Injectable({
  providedIn: 'root',
})
export class CpanelService {
  constructor(
    private vay: VayService,
    private http: HttpClient,
    private mingoErrorsHandler: MingoErrorsHandler,
    private vayAnt: VayAntService
  ) {}

  contactus() {
    return this.vay.VayVay('/contactus');
  }
  notification() {
    return this.vay.VayVay('/notification');
  }
  faq() {
    return this.vay.VayVay('/faq');
  }
  country() {
    return this.vay.VayVay('/country');
  }
  planCountry() {
    return this.vay.VayVay('/plan/country');
  }
  adminDashboard() {
    return this.vay.VayVay('/user/admin');
  }
  gateway() {
    return this.vay.VayVay('/gateway');
  }
  paymentSetting() {
    return this.vay.VayVay('/user/paymentsetting');
  }
  deliverySetting() {
    return this.vay.VayVay('/user/paymentsetting/delivery');
  }
  onlinOrderSetting() {
    return this.vay.VayVay('/user/paymentsetting/online');
  }

  paymentAdminSetting() {
    return this.vay.VayVay('/user/admin/add/paymentsettings');
  }
  category() {
    return this.vay.VayVay('/category');
  }
  settings() {
    return this.vay.VayVay('/settings');
  }
  table() {
    return this.vay.VayVay('/table');
  }
  profile() {
    return this.vay.VayVay('/blog');
  }
  menuItem() {
    return this.vay.VayVay('/menuitem');
  }
  menuItemAdmin() {
    return this.vay.VayVay('/menuitem/admin/data');
  }
  resturantForAdmin() {
    return this.vay.VayVay('/user/admin/resturants');
  }
  resturantDelete() {
    return this.vay.VayVay('/user/admin/resturant/delete');
  }
  allResturantForAdmin() {
    return this.vay.VayVay('/user/admin/resturant/alldata');
  }
  editResturantForAdmin() {
    return this.vay.VayVay('/user/admin/resturant/editdata');
  }
  addResturantForAdmin() {
    return this.vay.VayVay('/user/admin/resturant/add');
  }
  getOneResturantForAdmin() {
    return this.vay.VayVay('/user/admin/resturant/data');
  }
  slider() {
    return this.vay.VayVay('/slider');
  }
  orders() {
    return this.vay.VayVay('/order');
  }
  plans() {
    return this.vay.VayVay('/plan');
  }
  subscriptions() {
    return this.vay.VayVay('/user/customer/suscribs');
  }
  uploadExcel() {
    return this.vay.VayVay('/upload/excel');
  }
  usersetting() {
    return this.vay.VayVay('/usersetting');
  }
  coupon() {
    return this.vay.VayVay('/coupon/private');
  }
  adminCoupon() {
    return this.vay.VayVay('/coupon');
  }
  getAllCategories() {
    return this.http.get(`${BaseURL}/api/category/categoryForMenuItem`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getAllItems(_params?: any) {
    let params = new HttpParams();

    if (_params) {
      Object.keys(_params).map((key: any) => {
        params = params.append(key, _params[key] != null ? _params[key] : '');
      });
    }

    return this.http.get(`${BaseURL}/api/menuitem/dropdown/getall`, { params: params }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getAllCookers() {
    return this.http.get(`${BaseURL}/api/user/cookers`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getAllCurrencies() {
    return this.http.get(`${BaseURL}/api/country/frontend`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getTotalsForOrders(_params: any) {
    let params = new HttpParams();

    Object.keys(_params).map((key: any) => {
      params = params.append(key, _params[key] != null ? _params[key] : '');
    });

    return this.http.get(`${BaseURL}/api/order/mony`, { params: params }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getAllPaymentSetting() {
    return this.http.get(`${BaseURL}/api/gateway/dropdown/all`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getAllAdminPaymentSetting() {
    return this.vay.VayVay('/user/admin/get/paymentsettings');
  }

  getAllMenuItems() {
    return this.http.get(`${BaseURL}/api/order/items`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getAllTables() {
    return this.http.get(`${BaseURL}/api/order/tables`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getMenuOptions(id: any) {
    return this.http.get(`${BaseURL}/api/menuitem/options/${id}`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  activeplanCountry(id: any) {
    return this.http.put(`${BaseURL}/api/plan/${id}/country/active`, {}).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  saveMenuOptions(id: any, data: any) {
    return this.http.post(`${BaseURL}/api/menuitem/options/${id}`, data).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  refundOrder(id: any) {
    return this.http.post(`${BaseURL}/api/order/refundOrder`, { orderId: id }).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }
  refundTipOrder(id: any) {
    return this.http.post(`${BaseURL}/api/order/refundTrip`, { orderId: id }).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  markOrdersAsPaid(fields: any) {
    return this.http.post(`${BaseURL}/api/order/payOrdersForDriver`, { orders: fields }).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  orderPay(id: any) {
    return this.http.post(`${BaseURL}/api/order/paid`, id).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  orderTipPay(id: any) {
    return this.http.post(`${BaseURL}/api/order/paidTrip`, id).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getSubscriptionsStatus() {
    return this.http.get(`${BaseURL}/api/user/customer/subscribestatus`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getPlans() {
    return this.http.get(`${BaseURL}/api/user/plandata`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getSubscriptionsStatusInit() {
    return this.http.get(`${BaseURL}/api/user/customer/initsubscribe`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  addSubsicription(data: any) {
    return this.http.post(`${BaseURL}/api/user/customer/add`, data).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  verifySubsicription(data: any) {
    return this.http.post(`${BaseURL}/api/user/customer/verify`, data).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  cancelSubscriptions() {
    return this.http.put(`${BaseURL}/api/user/customer/suscribe/cancel`, {}).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  orderEmail(id: any) {
    return this.http.post(`${BaseURL}/api/order/emailit`, id).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  orderTipEmail(id: any) {
    return this.http.post(`${BaseURL}/api/order/emailTrip`, id).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  export(id: any, _params: any) {
    let params = new HttpParams();

    Object.keys(_params).map((key: any) => {
      params = params.append(key, _params[key] != null ? _params[key] : '');
    });
    return this.http.post(`${BaseURL}/api/order/file`, id, { params: params }).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  editMenuOptions(id: any, data: any) {
    return this.http.put(`${BaseURL}/api/menuitem/options/${id}`, data).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  sendReplay(id: any, body: any) {
    return this.http.post(`${BaseURL}/api/contactus/${id}/replay`, body).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }
  test() {
    return this.http.post(`https://saudi.hakbah.com/api/v1/payment/checkoutApple`, {}).pipe(
      map((res: any) => {
        // this.vayAnt.showMessage(res.message);

        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getCountryConfig() {
    return this.http.get(`${BaseURL}/api/user/config`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getPaymentConfig(_params: any) {
    let params = new HttpParams();

    Object.keys(_params).map((key: any) => {
      params = params.append(key, _params[key] != null ? _params[key] : '');
    });
    return this.http.get(`${BaseURL}/api/country/frontend/dashbord`, { params: params }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getAllPlans(_params: any) {
    let params = new HttpParams();

    Object.keys(_params).map((key: any) => {
      params = params.append(key, _params[key] != null ? _params[key] : '');
    });
    return this.http.get(`${BaseURL}/api/plan/country/currentcountry`, { params: params }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }

  getPlansForDrop() {
    return this.http.get(`${BaseURL}/api/plan/frontend`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }
}
